<template>
    <div class="vepCalculator">
        <div class="vepCalculator__grid">
            <div class="vepCalculator__column form">
                <p class="intro">Please fill out all of the following specifications to view suggested products. <span>All answers are required.</span></p>

                <div class="vepCalculator__form">

                    <label class="vepCalculator__label">
                    What is the pipe type?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="pipeType" @change="e => setPipeType(e.target.value)">
                                <option value="" disabled selected>Pipe type &hellip;</option>
                                <option v-for="option in pipeTypeOptions" :value="option">{{ option }}</option>
                            </select>
                        </label>
                    </div>
                    <label class="vepCalculator__label">
                        What is your system supported by?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="systemSupport" @change="e => setSystemSupport(e.target.value)">
                                <option value="" disabled selected>System support &hellip;</option>
                                <option v-for="option in systemSupportOptions" :value="option">{{ option }}</option>
                            </select>
                        </label>
                    </div>

                    <label class="vepCalculator__label">
                        What is the temperature range you are supporting?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="temperatureRange" @change="e => setTemperatureRange(e.target.value)">
                                <option value="" disabled selected>Temperature range &hellip;</option>
                                <option v-for="option in temperatureRangeOptions" :value="option">{{ option }}</option>
                            </select>
                        </label>
                    </div>
                    <label class="vepCalculator__label">
                        What is the hanger spacing?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="hangerSpacing" @change="e => setHangerSpacing(e.target.value)">
                                <option value="" disabled selected>Hanger spacing &hellip;</option>
                                <option v-for="option in hangerSpacingOptions" :value="option">{{ option }}</option>
                            </select>
                        </label>
                    </div>
                    <label class="vepCalculator__label">
                        Does your system require a 25/50 Flame/Smoke rating?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="flameRatingRequired" @change="e => setFlameRatingRequired(e.target.value == 'true')">
                                <option :value="false">No</option>
                                <option :value="true">Yes</option>
                            </select>
                        </label>
                    </div>
                    <label class="vepCalculator__label">
                        What is the nominal pipe size?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="nominalPipeSize" @change="e => setNominalPipeSize(e.target.value)">
                                <option value="" disabled selected>Pipe size &hellip;</option>
                                <option v-for="([label, value]) in pipeSizeOptions" :value="value">{{ label }}</option>
                            </select>
                        </label>
                    </div>
                    <label class="vepCalculator__label">
                        What is the insulation thickness?
                    </label>
                    <div class="vepCalculator__select">
                        <label class="selectWrap">
                            <select class="vepCalculator__input" :value="insulationThickness" @change="e => setInsulationThickness(e.target.value)">
                                <option value="" disabled selected>Insulation thickness &hellip;</option>
                                <option v-for="option in insulationThicknessOptions" :value="option">{{ option }}</option>
                            </select>
                        </label>
                    </div>
                </div>
            </div>

            <div class="vepCalculator__column accent"></div>

            <div class="vepCalculator__column results">

                <!-- Product block default state -->

                <div v-if="!filledIn" class="vepCalculator__null">
                    <p class="intro">Select answers to the questions on the left regarding your project specifications and suggested VEP products will appear here.</p>
                </div>

                <!-- Product block -->
                <div v-if="filledIn" class="vepCalculator__products">
                    <h2 class="-branBlue">Recommended<br>Products</h2>

                    <!-- Notice / Alert -->
                    <div v-if="temperatureRecommendation || insulationRecommendation || surfaceRecommendation" class="vepCalculator__recommendation">
                        <p class="-branBlue m-0">Please note...</p>
                        {{ temperatureRecommendation }}
                        {{ insulationRecommendation }}
                        {{ surfaceRecommendation }}
                    </div>

                    <!-- Returned Products -->

                    <a :href="product.url" v-for="product in recommendedProducts" :key="product.slug" class="vepCalculator__recommendedProducts">
                        <div>
                            <h3 class="-brandBlue -productName">{{ product.name }}</h3>
                            <p class="cta">Learn More</p>
                        </div>
                        <div>
                            <img class="image" :src="product.image" :alt="product.name">
                        </div>
                    </a>

                    <!-- Custom Product -->
                    <div class="vepCalculator__custom" v-if="recommendedProducts.length === 0">
                        <h2 class="-brandBlue">A custom product may be required. Please contact ASC Sales.</h2>
                        <p class="button"><a href="mailto:vepsales@asc-es.com">Contact Sales</a></p>
                    </div>
                </div>

            </div>
        </div>
        <footer class="vepCalculator__footer">
            <span>Need additional assistance?</span>
            <p>You can reach our team by emailing us via the link below or calling 303-715-9990.</p>
            <p class="button"><a href="mailto:vepsales@asc-es.com">Contact ASC</a></p>
        </footer>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState('vepCalculator', [
            'systemSupportOptions',
            'systemSupport',
            'temperatureRangeOptions',
            'temperatureRange',
            'hangerSpacingOptions',
            'hangerSpacing',
            'flameRatingRequired',
            'nominalPipeSize',
            'pipeTypeOptions',
            'pipeType',
            'insulationThicknessOptions',
            'insulationThickness',
        ]),

        ...mapGetters('vepCalculator', [
            'temperatureRecommendation',
            'insulationRecommendation',
            'surfaceRecommendation',
            'filledIn',
            'recommendedProducts',
            'pipeSizeOptions',
        ]),
    },
    methods: {
        ...mapMutations('vepCalculator', [
            'setSystemSupport',
            'setTemperatureRange',
            'setHangerSpacing',
            'setFlameRatingRequired',
            'setNominalPipeSize',
            'setPipeType',
            'setInsulationThickness',
        ]),
    },
}
</script>
